"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetBetaMessagingHash = exports.useBetaMessaging = void 0;
var React = __importStar(require("react"));
/**
 * Keep track of which components have been warned about to avoid spamming
 * the console
 */
var HASH = {};
var DOCS_BASE_URL = "https://design.granular.ag/design-system/components/";
var printTBDAbleDate = function (d) {
    return d instanceof Date ? d.toLocaleDateString() : d;
};
var STATIC_MESSAGES = {
    active: "Beta components may change without warning. We recommend keeping beta content behind feature flags. If you need this content in prod before the date below, please contact the Apollo team.",
    released: "This component has been released. Please switch over to the production version.",
    willNotRelease: "This component has been slated for removal without release. Please cease use before the removal date. If your needs are not met by another component, please contact the Apollo team.",
};
var useBetaMessaging = function (metadata) {
    var name = metadata.name, status = metadata.status, releaseDate = metadata.releaseDate, removeDate = metadata.removeDate, docsAt = metadata.docsAt;
    React.useEffect(function () {
        if (!HASH[name]) {
            var isTBDCleanup = status === "willNotRelease" && removeDate === "TBD";
            var releaseDateMessage = status === "willNotRelease"
                ? "Release date: N/A"
                : status === "active"
                    ? "Projected Release Date: " + printTBDAbleDate(releaseDate)
                    : "Release Date: " + printTBDAbleDate(releaseDate);
            var removalDateMessage = "Removal Date: " + printTBDAbleDate(removeDate) + (isTBDCleanup ? " - will provide at least sprint's notice." : "");
            var messages = [
                "GDS BETA WARNING: " + name + " [" + status + "]",
                STATIC_MESSAGES[status],
                releaseDateMessage,
                removalDateMessage,
                "Documentation is available at: " + (docsAt === "TBD" ? docsAt : DOCS_BASE_URL + docsAt),
            ].join("\n");
            window.console.info(messages);
            HASH[name] = metadata;
        }
    }, []);
};
exports.useBetaMessaging = useBetaMessaging;
var resetBetaMessagingHash = function () {
    HASH = {};
};
exports.resetBetaMessagingHash = resetBetaMessagingHash;
exports.default = exports.useBetaMessaging;
